import { render, staticRenderFns } from "./DataByPeriod.vue?vue&type=template&id=00452ea4&scoped=true&"
import script from "./DataByPeriod.vue?vue&type=script&lang=js&"
export * from "./DataByPeriod.vue?vue&type=script&lang=js&"
import style0 from "./DataByPeriod.vue?vue&type=style&index=0&id=00452ea4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00452ea4",
  null
  
)

export default component.exports